module.exports = __webpack_public_path__ + "static/media/box.d6280afa.svg";